/* eslint-disable import/prefer-default-export */
export const fetchUpgradePopup = prismicUid => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: 'FETCH_POPUP_CONTENT' });
    try {
        const prismicRes = await mainApi.get(`v1/content/popup/upgrade/${prismicUid}`);
        const data = await prismicRes.data;
        if (data.error) {
            dispatch({ type: 'FETCH_POPUP_CONTENT_FAILED', data: data.error });
        } else {
            console.log('content success');
            dispatch({ type: 'FETCH_POPUP_CONTENT_SUCCESS', data });
        }
    } catch (error) {
        dispatch({
            type: 'FETCH_POPUP_CONTENT_FAILED',
        });
    }
};
